import React, { createContext, useContext, useMemo, useState, useEffect, useCallback } from "react";
import { addLocale, useLocale as setTtagLocale, gettext } from "ttag";
import en from "./locales/en.po.json";
import ru from "./locales/ru.po.json";

addLocale("en", en);
addLocale("ru", ru);

const I18nContext = createContext({
  locale: "en",
  setLocale: () => {},
});

const detectNavigatorLocale = () => {
  if (typeof navigator !== "undefined") {
    const lang = (navigator.languages && navigator.languages[0]) || navigator.language || "";
    if (lang && lang.toLowerCase().startsWith("ru")) {
      return "ru";
    }
  }
  return "en";
};

const getInitialLocale = () => {
  if (typeof window === "undefined") {
    return "en";
  }
  
  // Сначала проверяем сохраненный выбор пользователя
  try {
    const savedLocale = localStorage.getItem("user_locale");
    if (savedLocale === "ru" || savedLocale === "en") {
      return savedLocale;
    }
  } catch (e) {
    // ignore
  }
  
  // Если сохраненного выбора нет, определяем по браузеру
  return detectNavigatorLocale();
};

const initialLocale = getInitialLocale();
setTtagLocale(initialLocale);

export const I18nProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(initialLocale);

  const setLocale = useCallback((newLocale) => {
    if (newLocale !== locale) {
      setLocaleState(newLocale);
      setTtagLocale(newLocale);
      // Сохраняем выбранный язык
      if (typeof window !== "undefined") {
        try {
          localStorage.setItem("user_locale", newLocale);
        } catch (e) {
          // ignore
        }
      }
    }
  }, [locale]);

  useEffect(() => {
    setTtagLocale(locale);
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
    }),
    [locale, setLocale]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);

// Обёртка над gettext с поддержкой подстановок вида %(name)s и {name}
export const t = (msgid, params) => {
  const translated = gettext(msgid);

  if (params && typeof params === 'object') {
    let result = translated;

    Object.entries(params).forEach(([key, value]) => {
      const safeValue = String(value);

      // Поддержка плейсхолдеров в стиле gettext: %(name)s
      const rePrintf = new RegExp(`%\\(${key}\\)s`, 'g');
      result = result.replace(rePrintf, safeValue);

      // Поддержка плейсхолдеров в стиле {name}
      const reBraces = new RegExp(`\\{${key}\\}`, 'g');
      result = result.replace(reBraces, safeValue);
    });

    return result;
  }

  return translated;
};


